import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./button";

/** Copies text to the clipboard with an accessible confirmation. */
export function CopyButton({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <Button
      size="sm"
      variant="secondary"
      aria-label={label}
      onClick={() => {
        void navigator.clipboard
          .writeText(value)
          .then(() => {
            setCopied(true);
            toast.success("Copiado al portapapeles");
            window.setTimeout(() => {
              setCopied(false);
            }, 1500);
          })
          .catch(() => toast.error("No se pudo copiar. Selecciona el texto y cópialo manualmente."));
      }}
    >
      {copied ? <Check /> : <Copy />}
      {copied ? "Copiado" : "Copiar"}
    </Button>
  );
}
